<template>
    <v-dialog v-model="visible" persistent max-width="500px">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>
                <span v-html="message"></span>
            </v-card-text>
            <v-card-actions>
                <v-btn text ref="btnCancel" @click="cancel">Cancelar</v-btn>
                <v-btn color="red" @click="confirm">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false, // Controla la visibilidad del diálogo
            title: '', // Título del diálogo
            message: '', // Mensaje del diálogo
            resolve: null, // Resolverá el Promise cuando el usuario interactúe
        };
    },
    methods: {
        open({ title, message }) {
            this.title = title;
            this.message = message;
            this.visible = true;
            // Espera a que el diálogo se muestre y enfoca el botón
            this.$nextTick(() => {
                this.$refs.btnCancel?.focus();
            });
            // Devolvemos una promesa que se resolverá cuando el usuario confirme o cancele
            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        },
        confirm() {
            this.resolve(true); // Resuelve la promesa con "true" al confirmar
            this.close();
        },
        cancel() {
            this.resolve(false); // Resuelve la promesa con "false" al cancelar
            this.close();
        },
        close() {
            this.visible = false;
            this.title = '';
            this.message = '';
        },
    },
};
</script>